import RouterHolder from '@/components/router-holder'
import * as ConstantRouter from '@/constant/router'

const route = {
  path: 'works-history',
  name: ConstantRouter.DASHBOARD_WORKS_HISTORY,
  component: RouterHolder,
  redirect: '/admin/works-history',
  children: [
    {
      path: '',
      component: () =>
        import(
          /* webpackChunkName: "dashboard-works-history" */ '@/dashboard/works-history'
        )
    },
    {
      path: 'add',
      name: ConstantRouter.DASHBOARD_WORKS_HISTORY_ADD,
      component: () =>
        import(
          /* webpackChunkName: "dashboard-works-history-add" */ '@/dashboard/works-history/add'
        )
    },
    {
      path: 'update/:id',
      name: ConstantRouter.DASHBOARD_WORKS_HISTORY_UPDATE,
      component: () =>
        import(
          /* webpackChunkName: "dashboard-works-history-update" */ '@/dashboard/works-history/add'
        )
    },
    {
      path: 'detail/:id',
      name: ConstantRouter.DASHBOARD_WORKS_HISTORY_DETAIL,
      component: () =>
        import(
          /* webpackChunkName: "dashboard-works-history-detail" */ '@/dashboard/works-history/detail'
        )
    }
  ]
}

export default route
